import { render, staticRenderFns } from "./aboutWmdjzg.vue?vue&type=template&id=4eb3b2ab&scoped=true&"
import script from "./aboutWmdjzg.vue?vue&type=script&lang=js&"
export * from "./aboutWmdjzg.vue?vue&type=script&lang=js&"
import style0 from "./aboutWmdjzg.vue?vue&type=style&index=0&id=4eb3b2ab&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eb3b2ab",
  null
  
)

export default component.exports